import axios from 'axios';
import config from '../config/config';
import { joinApiUrl } from '../config/api-url';

export const PACKAGE_HINT = 'Diese Funktion ist im Paket Zahlungsfunktion enthalten. Buchen Sie das Paket, um sie freizuschalten.';
export const OWN_PROVIDER = 'zahldienst_eigenenZahlungsdienstleisterFestlegen';
const unavailable = () => ({ PackageActive: false, StripeConnected: false, HasProductOrder: false,
  CanEnable: false, Reason: 'Die Zahlungsfreigabe konnte nicht geprüft werden. Bitte laden Sie die Seite erneut.' });
const url = path => joinApiUrl(config.API_URL, 'api/payment-eligibility' + path);
function headers() {
  const token = window.getOzgUserToken?.() || localStorage.getItem('ozgUserJwt') || localStorage.getItem('ozgJwt');
  return token ? { Authorization: 'Bearer ' + token } : {};
}
export function normalizeEligibility(data) {
  if (!data) return unavailable();
  const get = key => data[key] ?? data[key[0].toLowerCase() + key.slice(1)];
  const result = { PackageActive: get('PackageActive') === true, StripeConnected: get('StripeConnected') === true,
    HasProductOrder: get('HasProductOrder') === true, Reason: get('Reason') || null };
  result.CanEnable = result.PackageActive && result.StripeConnected && result.HasProductOrder;
  return result;
}
export async function loadEligibility() {
  try { return normalizeEligibility((await axios.get(url(''), { headers: headers() })).data); }
  catch (_) { return unavailable(); }
}
export async function prepareRows(rows) {
  rows.forEach(row => { row.paymentEligibility = unavailable(); row.paymentSaved = row.item.hasPayment === true; row.paymentSaving = false; });
  const ids = [...new Set(rows.map(row => Number(row.item.formId.id)).filter(id => id > 0))];
  for (let i = 0; i < ids.length; i += 200) {
    try {
      const response = await axios.post(url('/forms'), ids.slice(i, i + 200), { headers: headers() });
      rows.forEach(row => { if (response.data[row.item.formId.id]) row.paymentEligibility = normalizeEligibility(response.data[row.item.formId.id]); });
    } catch (_) { /* The failed batch remains locked. */ }
  }
}
export async function setPayment(row, enabled) {
  const previous = row.paymentSaved === true;
  if (row.paymentSaving || (enabled && !row.paymentEligibility?.CanEnable)) { row.item.hasPayment = previous; return; }
  if (!window.confirm(enabled ? 'Wollen Sie die Bezahlfunktion für dieses Formular aktivieren?' : 'Wollen Sie die Bezahlfunktion für dieses Formular deaktivieren?')) {
    row.item.hasPayment = previous;
    return;
  }
  row.paymentSaving = true;
  try {
    const response = await axios.put(url('/assignments/' + row.id), { enabled: !!enabled }, { headers: headers() });
    row.paymentSaved = response.data.hasPayment === true;
    row.item.hasPayment = row.paymentSaved;
  } catch (error) {
    row.item.hasPayment = previous;
    window.alert(error.response?.data?.message || 'Die Zahlungsänderung konnte nicht gespeichert werden.');
  } finally { row.paymentSaving = false; }
}

function walk(nodes, visitor) {
  if (!nodes || typeof nodes !== 'object') return;
  if (Array.isArray(nodes)) { nodes.forEach(node => walk(node, visitor)); return; }
  visitor(nodes);
  ['components', 'columns', 'rows', 'tabs'].forEach(key => walk(nodes[key], visitor));
}
export function applyPaymentDefinition(definition, eligibility) {
  let paymentPanel;
  walk(definition, component => {
    if (component.key === 'zahlungsarten1') paymentPanel = component;
    if (component.key === 'bezahl_ZahldienstAuswahl') {
      component.type = 'paymentproviderradio';
      component.ownProviderBlocked = !eligibility.PackageActive;
      component.description = eligibility.PackageActive ? component.description : (eligibility.Reason || PACKAGE_HINT);
    }
    if (component.key === 'bezahl_GesamtlisteZahlungsdienstleister') component.disabled = !eligibility.PackageActive || component.disabled === true;
    if (component.type === 'connecttostripe') {
      component.paymentPackageBlocked = !eligibility.PackageActive;
      component.disabled = !eligibility.PackageActive || component.disabled === true;
    }
  });
  if (!paymentPanel) return definition;
  // DEV05 currently has a provider selector but no Stripe panel. Keep existing fields.
  let hasStripe = false;
  walk(paymentPanel, component => { if (component.type === 'connecttostripe') hasStripe = true; });
  if (!hasStripe) {
    paymentPanel.components.push({ type: 'panel', key: 'ozgStripeConnection', title: 'Stripe verbinden', input: false,
      collapsible: false, disabled: !eligibility.PackageActive,
      customConditional: eligibility.PackageActive ? `show = data.bezahl_ZahldienstAuswahl === '${OWN_PROVIDER}';` : '',
      components: [
        ...(!eligibility.PackageActive ? [{ type: 'content', key: 'ozgPaymentBookingHint', input: false,
          html: '<p>' + PACKAGE_HINT + '</p>' }] : []),
        { type: 'connecttostripe', key: 'connectToStripe', label: eligibility.StripeConnected ? 'Mit Stripe erneut verbinden' : 'Mit Stripe verbinden',
          input: false, disabled: !eligibility.PackageActive, paymentPackageBlocked: !eligibility.PackageActive }
      ] });
  }
  return definition;
}
export async function prepareDefinition(definition) {
  let needed = false;
  walk(definition, c => { if (c.key === 'bezahl_ZahldienstAuswahl' || c.type === 'connecttostripe') needed = true; });
  return needed ? applyPaymentDefinition(definition, await loadEligibility()) : definition;
}
window.OzgPayment = { prepareRows, setPayment, prepareDefinition };
